<template>
  <Modal
    titleV2="Pré-Configuração"
    :value="modalFiscalValidationIsOpen"
    :onClose="toggleModalFiscalValidation"
    :close="false"
  >
    <b-row>
      <b-col class="mb-3 text-center">
        Antes de iniciar a emissão de sua NFS-e verifique se os dados de sua
        empresa e a configuração para emissão estão corretamente preenchidos.
        <div class="font-weight-bold">
          (emissão disponível somente para certificado A1)
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3 text-muted" align-v="center">
      <b-col sm="5" align="right">
        <Check
          v-if="fiscalValidation.configuration"
          class="icon-2x text-success"
        />
        <Close v-else class="icon-2x color-red" />
      </b-col>
      <b-col
        sm="4"
        class="pl-0"
        align="left"
        style="cursor: pointer"
        @click="goToNfseConfiguration"
      >
        <h5>Configurações</h5>
      </b-col>
    </b-row>
    <b-row class="mt-3 text-muted" align-v="center">
      <b-col sm="5" align="right">
        <Check
          v-if="fiscalValidation.companyData"
          class="icon-2x text-success"
          title="Salvar"
        />
        <Close v-else class="icon-2x color-red" title="Cancelar" />
      </b-col>
      <b-col
        sm="4"
        class="pl-0"
        align="left"
        style="cursor: pointer"
        @click="goToCompanyData"
      >
        <h5>Dados da empresa</h5>
      </b-col>
    </b-row>
  </Modal>
</template>

<script>
import Close from 'vue-material-design-icons/CloseCircleOutline';
import Check from 'vue-material-design-icons/CheckCircleOutline';
import { mapActions, mapState } from 'vuex';
import { Modal } from '@/components';

export default {
  name: 'ModalFiscalValidationNFSe',
  components: {
    Modal,
    Close,
    Check,
  },
  computed: {
    ...mapState('nfse', ['fiscalValidation']),
    ...mapState('nfseComponents', ['modalFiscalValidationIsOpen']),
  },
  methods: {
    ...mapActions('nfseComponents', ['toggleModalFiscalValidation']),

    goToNfseConfiguration() {
      window.location.href = '/v2.html#/fiscal/nfse/configurations/';
    },
    goToCompanyData() {
      window.location.href = '/#/account/edit/';
    },
  },
};
</script>;

<style scoped>
.icon-2x {
  height: 2em;
  width: 2em;
}

.icon-2x > .material-design-icon__svg {
  height: 2em;
  width: 2em;
}
</style>
